import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.SplitViewGoToBar', {
    goBack: 'Go back',
    goTo: 'Go to {contentName}',
    backTo: 'Back to {contentName}',
});
